import Search from '@src/main/ui/components/Search/Search';
import { type FC } from 'react';

const SearchPage: FC = () => <Search />;

export default SearchPage;
